export default __webpack_public_path__ + "static/media/Others_Head_Bounce.37bb9372.svg";